import React from "react";
import bannerImage from "../../../assets/images/rockinyangon/bannerGroup.png";
import groupImg from "../../../assets/images/rockinyangon/group.jpg";

const Banner = () => {
  return (
    <div className="">
      {/* <img src={groupImg} alt="" /> */}
    <div className="  py-20 pt-28 flex md:flex-row flex-col justify-between bg-[#1D1D1D] px-5 md:px-10 lg:px-14">
      <div className="order-2 md:order-1 flex flex-col  justify-center gap-4">
        <div className="w-28 h-[2px] bg-[#E83B37]" />

        <h1 className="capitalize text-[#E83B37] text-3xl lg:text-4xl titlefont ">
          Rock in Yangon
        </h1>
        <h1 className="lg:text-2xl text-xl font-bold text-white">
         နေ့ရက် : အောက်တိုဘာ ၂၁ ရက်
        </h1>
        <h1 className="lg:text-2xl text-xl font-bold text-white">
        အချိန် :  ညနေ ၆ နာရီ မှ ၁၀ နာရီထိ
        </h1>
        <h2 className=" text-lg lg:text-xl textfont font-semibold text-white/70">
          Yangon Hexagon Complex
        </h2>
        <button className="w-[200px] py-2 hover:bg-transparent border border-[#ed3E3D] hover:rounded-lg rounded-md transition-all text-white bg-[#ED3E3D]">
          Ticket ၀ယ်ယူရန်
        </button>
      </div>
      <div className="order-1 md:order-2 flex items-center">
        <div className="lg:w-[700px] md:w-[500px] h-[200px]">
          <img src={bannerImage} className=" w-full h-full object-cover " alt="" />
        </div>
      </div>
    </div>
    </div>
  );
};

export default Banner;
